module.exports = __webpack_public_path__ + "static/media/loading_default.8247d567.svg";